<div class="category-tree">
	<!-- Level 1: the category groups themselves -->
	<ng-container *ngIf="level === 'segments'">
		<div class="d-flex flex-row mb-2 align-items-center">
			<h4 class="flex-weight-1 mr-1 mb-0">Category groups</h4>
			<span class="text-secondary text-tiny nowrap">{{ totalCategories }} categories</span>
		</div>

		<div *ngFor="let segment of segments" class="bg-white border border-lightgrey rounded overflow-hidden mb-2 selectable hoverable" (click)="openSegment(segment)">
			<div class="border-top border-3" [ngClass]="'border-' + segmentColor(segment.segment)"></div>
			<div class="p-2">
				<div class="d-flex flex-row align-items-center">
					<span class="text-bold text-dark flex-weight-1 mr-2">{{ segment.segment }}</span>
					<span class="text-dark text-small nowrap">{{ segment.product_count | decimal:0 }}</span>
				</div>
				<div class="text-secondary text-tiny">{{ segment.category_count }} categories &middot; {{ segment.subcategory_count }} sub</div>
			</div>
		</div>
	</ng-container>

	<!-- Level 2 and 3 share a back header naming where you are -->
	<ng-container *ngIf="level !== 'segments'">
		<div class="d-flex flex-row mb-2 align-items-center">
			<span class="text-primary text-tiny text-uppercase text-bold selectable nowrap mr-2" (click)="back()">
				<i class="wq wq-angle-left"></i> Back
			</span>
			<h4 class="flex-weight-1 mb-0 text-truncate">{{ category ? category.category : segment.segment }}</h4>
			<span class="text-secondary text-tiny nowrap ml-1">{{ (category ? category.product_count : segment.product_count) | decimal:0 }}</span>
		</div>
	</ng-container>

	<!-- Level 2: categories within the group -->
	<ng-container *ngIf="level === 'categories'">
		<div class="category-list">
			<div *ngFor="let category of segment.categories" class="bg-white border border-lightgrey rounded p-2 mb-2 selectable hoverable d-flex align-items-center" (click)="openCategory(category)">
				<div class="flex-weight-1 mr-2">
					<div class="text-dark text-truncate">{{ category.category }}</div>
					<div class="text-secondary text-tiny">{{ category.product_count | decimal:0 }} &middot; {{ category.subcategory_count }} sub</div>
				</div>
				<i class="wq wq-angle-right text-secondary"></i>
			</div>
		</div>
	</ng-container>

	<!-- Level 3: subcategories are ticked rather than navigated -->
	<ng-container *ngIf="level === 'subcategories'">
		<div class="bg-white border border-lightgrey rounded p-2 mb-2">
			<div class="text-dark">{{ category.category }}</div>
			<div class="text-secondary text-tiny">{{ category.product_count | decimal:0 }} products &middot; {{ category.subcategory_count }} subcategories</div>
		</div>

		<div class="input-group mb-2" *ngIf="category.subcategories?.length">
			<input class="form-control rounded-pill text-uppercase text-tiny" type="text" placeholder="Filter subcategories..." [(ngModel)]="subcategoryFilter">
		</div>

		<div class="subcategory-list">
			<div *ngFor="let subcategory of visibleSubcategories">
				<label class="custom-control custom-checkbox m-0 mb-2 mr-3 d-flex align-items-center">
					<input type="checkbox" class="custom-control-input" [checked]="isSubcategorySelected(subcategory)" (change)="toggleSubcategory(subcategory)">
					<span class="custom-control-label text-tiny flex-weight-1 d-flex text-dark">
						<span class="text-truncate" [title]="subcategory.subcategory">{{ subcategory.subcategory }}</span>
					</span>
					<span class="text-secondary text-tiny ml-2">{{ subcategory.product_count | decimal:0 }}</span>
				</label>
			</div>
			<div *ngIf="!visibleSubcategories.length" class="text-secondary text-tiny">No subcategories.</div>
		</div>
	</ng-container>
</div>
